import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },
  routes: [{
      path: '*',
      redirect: '/index'
    },
    {
      path: '/aaa',
      name: 'aaa',
      component: () => import('@/pages/Aaa'),
      meta: {
        keepAlive: false,
        title: '首页',
        titleEn: 'Home Page',
        showHead: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/pages/Login'),
      meta: {
        keepAlive: false,
        title: '登录',
        titleEn: 'Login',
        showHead: false
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/pages/Register'),
      meta: {
        keepAlive: false,
        title: '注册',
        titleEn:'Register',
        showHead: false
      }
    },
    {
      path: '/password',
      name: 'password',
      component: () => import('@/pages/Password'),
      meta: {
        keepAlive: false,
        title: '忘记密码',
        titleEn:'Forget password',
        showHead: false
      }
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('@/pages/Index'),
      meta: {
        keepAlive: false,
        title: '首页',
        titleEn: 'Home Page',
        showHead: true,
        showCurrentExhibition:true
      }
    },
    {
      path: '/exhibition',
      name: 'exhibition',
      component: () => import('@/pages/Exhibition'),
      meta: {
        keepAlive: false,
        title: '切换展会',
        titleEn:'Switch Exhibition',
        showHead: true,
        showCurrentExhibition:true
      }
    },
    {
      path: '/addPlace',
      name: 'addPlace',
      component: () => import('@/pages/AddPlace'),
      meta: {
        keepAlive: false,
        title: '添加展位',
        titleEn:'Add Booth',
        showHead: true,
        showCurrentExhibition:true
      }
    },
    {
      path: '/addFascia',
      name: 'addFascia',
      component: () => import('@/pages/AddFascia'),
      meta: {
        keepAlive: false,
        title: '添加楣板',
        titleEn:'FasciBoard',
        showHead: true,
        showCurrentExhibition:true
      }
    } ,
    {
      path: '/rent',
      name: 'rent',
      component: () => import('@/pages/Rent'),
      meta: {
        keepAlive: false,
        title: '租赁',
        titleEn:'Rental',
        showHead: true,
        showCurrentExhibition:true
      }
    },
    {
      path: '/rentUp',
      name: 'rentUp',
      component: () => import('@/pages/RentUp'),
      meta: {
        keepAlive: false,
        title: '定制服务',
        titleEn:'Shell Scheme Booth Upgrades',
        showHead: true,
        showCurrentExhibition:true
      }
    },
    {
      path: '/goodsDetail',
      name: 'goodsDetail',
      component: () => import('@/pages/GoodsDetail'),
      meta: {
        keepAlive: false,
        title: '物品详情',
        titleEn:'Item Specific',
        showHead: true,
        showCurrentExhibition:true
      }
    },
    {
      path: '/goodsCar',
      name: 'goodsCar',
      component: () => import('@/pages/GoodsCar'),
      meta: {
        keepAlive: false,
        title: '购物车',
        titleEn:'Cart',
        showHead: true,
        showCurrentExhibition:true
      }
    },
    {
      path: '/picture',
      name: 'picture',
      component: () => import('@/pages/Picture'),
      meta: {
        keepAlive: false,
        title: '报图',
        showHead: true,
        showCurrentExhibition:true
      }
    },
    {
      path: '/account',
      name: 'account',
      component: () => import('@/pages/Account'),
      meta: {
        keepAlive: false,
        title: '基本信息',
        titleEn:'General Information',
        showHead: true,
        showCurrentExhibition:true
      }
    },
    {
      path: '/notification',
      name: 'notification',
      component: () => import('@/pages/Notification'),
      meta: {
        keepAlive: false,
        title: '违规通知',
        titleEn:'Non-Compliance Notices',
        showHead: true,
        showCurrentExhibition:false
      }
    },
    {
      path: '/material',
      name: 'material',
      component: () => import('@/pages/Material'),
      meta: {
        keepAlive: false,
        title: '补资料',
        titleEn:'Supplementary Information',
        showHead: true,
        showCurrentExhibition:false
      }
    },
    {
      path: '/booth',
      name: 'booth',
      component: () => import('@/pages/Booth'),
      meta: {
        keepAlive: false,
        title: '我的展位',
        titleEn:'My Booth',
        showHead: true,
        showCurrentExhibition:false
      }
    },
    {
      path: '/invoice',
      name: 'invoice',
      component: () => import('@/pages/Invoice'),
      meta: {
        keepAlive: false,
        title: '开发票',
        titleEn:'Invoice',
        showHead: true,
        showCurrentExhibition:false
      }
    },
    {
      path: '/depositRefund',
      name: 'depositRefund',
      component: () => import('@/pages/DepositRefund'),
      meta: {
        keepAlive: false,
        title: '退押金',
        titleEn: 'Deposit Refund',
        showHead: true,
        showCurrentExhibition:false
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/pages/About'),
      meta: {
        keepAlive: false,
        title: '关于盛事',
        titleEn: 'About us',
        showHead: false,
        showCurrentExhibition:false
      }
    },
    {
      path: '/manual',
      name: 'manual',
      component: () => import('@/pages/manual'),
      meta: {
        keepAlive: false,
        title: '操作手册',
        titleEn: 'Operation Manual',
        showHead: false,
        showCurrentExhibition:false
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js